import { useTranslation } from 'react-i18next';

export interface ExpiryLabelProps {
  date: string;
}

function ExpiryLabel(props: ExpiryLabelProps) {
  const { t } = useTranslation();
  const date = new Date(Date.parse(props.date));
  const formatedDate = date.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: '2-digit' });

  return (
    <div className="ct_expiryLabel">
      {t('Until', { ns: 'partner' })}
      {' '}
      <span>
        {formatedDate}
      </span>
    </div>
  );
}

export default ExpiryLabel;
